export class Moneda {
  constructor(
    public readonly Id: number,
    public readonly Codigo: string | null,
    public readonly Nombre: string | null,
    public  Activo: boolean
  ) {}
}

export class SearchMonedaRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    public readonly RolId: number | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}
export class SaveMonedaDto {
  constructor(
    public Nombre: string | null,
    public Codigo: string | null,
    public Activo: boolean
  ) {}
}

export class SearchMonedaResponse {
  constructor(
    public readonly count: number,
    public readonly result: Moneda[]
  ) {}
}

export class ConversionMoneda {
  constructor(
      public readonly Id: number,
      public readonly FechaCotizacion: Date,
      public readonly MonedaOrigenId: number | null,
      public readonly MonedaOrigen: string | null,
      public readonly MonedaDestinoId: number | null,
      public readonly MonedaDestino: string | null,
      public readonly ValorCompra: number,
      public readonly ValorVenta: number,
      public readonly Activo: boolean,
      public readonly CoeficienteConversion: number
  ) {}
}

export class SearchConversionMonedaRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly FechaCotizacionDesde: Date | null,
    public readonly FechaCotizacionHasta: Date | null,
    public readonly MonedaOrigenId: number | null,
    public readonly MonedaDestinoId: number | null,
    public readonly VerSoloActivos: boolean
  ) {}
}

export class SearchConversionMonedaResponse {
  constructor(
    public readonly count: number,
    public readonly result: ConversionMoneda[]
  ) {}
}

export class SaveConversionMoneda {
  constructor(
      public readonly Id: number,
      public readonly FechaCotizacion: Date | null,
      public readonly MonedaOrigenId: number | null,
      public readonly MonedaDestinoId: number | null,
      public readonly ValorCompra: number,
      public readonly ValorVenta: number,
      public readonly Activo: boolean
  ) {}
}
